import React from 'react';
import ReactDOM from 'react-dom';
import SellerCard from './SellerCard';

const componentElm = typeof document !== 'undefined' && document.getElementById('SellerCard-component');

if (componentElm) {
    const initialState = window.initialData.SellerCard;

    ReactDOM.render(
        <SellerCard {...initialState}/>,
        componentElm
    );
}

export default SellerCard;



// WEBPACK FOOTER //
// ./src/index.js